import { useState } from "react";

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : initialValue;
  });

  const setValue = (value: T) => {
    const valueToStore = value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    window.localStorage.setItem(key, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue] as [T, typeof setValue];
}

export type UserData = {
  isLoggedIn: boolean;
  username?: string;
  violations: number;
  lastViolation?: number;
  violationContent?: string;
};

export const BLANK_USER_DATA: UserData = {
  isLoggedIn: false,
  violations: 0,
};

export const SUSPENSION_DURATION = 4; // Minutes. Don't make this less than 2.
